<template>
  <header class="yj-header" :style="{ height }">
    <slot></slot>
  </header>
</template>

<script>
  export default {
    name: 'YjHeader',

    componentName: 'YjHeader',

    props: {
      height: {
        type: String,
        default: '60px'
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/header/src/header.vue